import Stack, { StackProps } from '@mui/material/Stack';
import { ReactNode } from 'react';

import { TabId } from '../../types';

type Props = {
  id: TabId;
  containerProps?: StackProps;
  children?: ReactNode;
  activeTabId: TabId;
};

function TabPanel({ id, containerProps, children, activeTabId }: Props) {
  const isActive = activeTabId === id;

  return (
    <Stack
      id={`build-preview-tabpanel-${id}`}
      role="tabpanel"
      aria-labelledby={`build-preview-tab-${id}`}
      hidden={!isActive}
      flex={isActive ? 1 : 0}
      display={isActive ? 'flex' : 'none'}
      {...containerProps}
    >
      {isActive && <>{children}</>}
    </Stack>
  );
}

export default TabPanel;
